import { darkColors, lightColors } from '@tryhackme/thm-ui-components';
import { css } from 'styled-components';

export const DarkModeMainAdjustmentStyles = css<{ $isDark: boolean }>`
  ${({ $isDark }) =>
    $isDark &&
    css`
      [style*='color:rgb(136, 204, 20);'] {
        color: ${darkColors.primary.main} !important;
      }
      [style*='color:rgb(14, 16, 26);'] {
        color: white !important;
      }
      [style*='color:rgb(0, 0, 0);'] {
        color: white !important;
      }
      [style*='color:rgb(67, 67, 67);'] {
        color: white !important;
      }

      p {
        color: ${$isDark ? darkColors.text.light : lightColors.text.main} !important;
      }

      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      ul,
      li {
        color: ${$isDark ? darkColors.text.light : lightColors.text.main};
      }
      .badge-soft-dark {
        color: #919398 !important;
        background-color: rgba(99, 99, 99, 0.18) !important;
      }

      .badge-soft-primary {
        color: ${darkColors.info.main} !important;
        background-color: ${darkColors.info.light} !important;
      }

      .badge-soft-info {
        color: #2ee7b6 !important;
        background-color: rgba(46, 231, 182, 0.18) !important;
      }

      .badge-soft-success {
        color: ${darkColors.success.main} !important;
        background-color: ${darkColors.success.lightest} !important;
      }

      .badge-soft-danger {
        color: ${darkColors.error.main} !important;
        background-color: ${darkColors.error.light} !important;
      }

      .badge-soft-purple {
        color: ${darkColors.purple.main} !important;
        background-color: ${darkColors.purple.lighter} !important;
      }

      .badge-soft-warning {
        color: ${darkColors.warning.main} !important;
        background-color: ${darkColors.warning.lightest} !important;
      }
    `}
`;

export const DarkModeTableAdjustmentStyles = css<{ $isDark: boolean }>`
  ${({ $isDark, theme }) =>
    $isDark &&
    `
    td {
      background-color : ${theme.colors.background.main} !important;
    }
  `}
`;
